import React from "react";
import news1 from "../../../assets/img/news1.png";
import news2 from "../../../assets/img/news2.png";

import { Link } from "react-router-dom";
import { MdOutlineArrowOutward } from "react-icons/md";

const NewsSection = () => {
	const cards = [
		{
			imgSrc: news1,
		},
		{
			imgSrc: news2,
		},
	];

	return (
		<section className=' bg-[#F6FEFA]'>
			<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-8'>
				<div className=''>
					<h2 className='text-3xl md:text-5xl font-semibold text-[#1D1D1D] leading-tight'>
						News And Events
					</h2>
					<p className='text-lg text-[#11112d] font-normal mt-4 leading-relaxed'>
						Stay updated on the latest news and upcoming events from Synergy
						Care Foundation.
					</p>
				</div>
				<div className=' flex flex-col md:flex-row justify-between gap-8'>
					{cards.map((card, index) => (
						<img
							key={index}
							src={card.imgSrc}
							alt={`Card ${index + 1}`}
							className='w-full md:w-1/2 h-auto'
						/>
					))}
				</div>
				<Link
					to='/news-event'
					className='md:text-2xl text-lg text-[#15A359] font-normal mt-8 leading-relaxed flex items-center gap-x-1 hover:underline decoration-[#15A359] underline-offset-4 decoration-2'>
					<span>
						Explore our latest initiatives, community stories, and upcoming
						events
					</span>

					<MdOutlineArrowOutward />
				</Link>
				{/* <p className='text-2xl/10 font-semibold mt-16 text-center'>
					Sign up <span className='text-[#1bb96a]'>below</span> to get notified
					when we publish new content
				</p> */}
			</div>
		</section>
	);
};

export default NewsSection;
